<template>
  <div class="relative">
    <div class="flex">
      <div class="title-bar">
        <div class="timezone-header" data-cy="time-zone-title">{{ $t('time_zone') }}</div>
        <div class="timezone-subheader">
          {{ $t('customize', { thing: $t('time_zone') }) }}
        </div>
      </div>
    </div>
    <div class="">
      <div class="m-auto w-full">
        <base-simple-search-box
          id="s_time_zone"
          width="full"
          height="50"
          class="mb-20"
          type="timeZone"
          radius="sm"
          :placeholder="$t('search')"
          @searchedText="getSearchedText"
        />
        <div class="max-h-438 overflow-y-scroll">
          <div
            class="timezone-content"
            v-for="item in filteredList()"
            :key="item.name"
            @click="setTimeZoneHandler(item.name)"
          >
            <div
              :class="{ 'default-timezone': defaultTimezone === item.name }"
              class="bordered-box px-10 py-5"
            >
              <div>
                <div
                  class="timezone-content-header"
                  :class="defaultTimezone === item.name ? 'text-blueText' : 'text-title'"
                >
                  {{
                    defaultTimezone === item.name
                      ? $t('default_time_zone')
                      : $t('time_zone')
                  }}
                </div>
                <div class="timezone-content-main">
                  {{ item.name }}
                </div>
              </div>
              <tick-icon v-if="defaultTimezone === item.name" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import timeZones from '@/config/timeZones';
import axiosConfig from '@/services/axios.config';
import serverErrorsHandler from '@/utils/serverErrorsHandler';
import BaseSimpleSearchBox from '@/components/base/BaseSimpleSearchBox.vue';

import TickIcon from '@/assets/icons/vue/FillTick.vue';

export default {
  name: 'TimeZone',
  computed: {
    ...mapGetters({
      isLoading: 'loading/getActiveSkeletons',
    }),
  },
  components: {
    BaseSimpleSearchBox,
    TickIcon,
  },
  data() {
    return {
      timezones: timeZones,
      searchedContent: '',
      defaultTimezone: '',
      TimeZoneIndex: 0,
      findTimeZone: '',
    };
  },
  mounted() {
    this.getSettings();
  },
  methods: {
    filteredList() {
      // eslint-disable-next-line max-len
      return this.timezones.filter((item) => item.name.toLowerCase().includes(this.searchedContent.toLowerCase()));
    },
    getSearchedText(text) {
      this.searchedContent = text;
    },
    getSettings() {
      axiosConfig
        .get('/user/get-setting')
        .then((response) => {
          this.defaultTimezone = response.data.data.timezone
            ? response.data.data.timezone
            : this.$store.state.authentication.user.timezone;
          this.TimeZoneIndex = this.timezones.findIndex(
            (item) => item.name === this.defaultTimezone,
          );
          this.timezones.splice(this.TimeZoneIndex, 1);
          this.timezones.unshift({ name: this.defaultTimezone, value: this.defaultTimezone });
        })
        .catch((error) => {
          serverErrorsHandler(error);
        });
    },
    setTimeZoneHandler(zoneName) {
      this.$store.commit('loading/DISABLE_HANDLER', true);
      this.defaultTimezone = zoneName;
      axiosConfig
        .post('/user/settings', { timezone: this.defaultTimezone })
        .then(() => {
          this.$toast.success(this.$t('changed'));
          this.$store.commit('loading/DISABLE_HANDLER', false);
        })
        .catch((error) => {
          serverErrorsHandler(error);
          this.$store.commit('loading/DISABLE_HANDLER', false);
        });
    },
  },
};
</script>
<style scoped>
.timezone-content:not(:nth-child(1)) {
  @apply my-20 cursor-pointer;
}
.bordered-box {
  @apply flex items-center justify-between border border-default rounded-sm overflow-y-auto
  bg-secondary;
}
.title-bar {
  @apply mb-32;
}
.back-button {
  @apply w-50 h-50 shadow-icon rounded flex absolute bg-secondary left-50;
}
.timezone-header {
  @apply text-24 font-bold text-title;
}
.timezone-subheader {
  @apply text-12 text-subtitle font-medium;
}
.timezone-content-header {
  @apply text-14 font-semibold;
}
.timezone-content-main {
  @apply text-14 font-semibold;
}
.default-timezone {
  @apply rounded-sm bg-tertiary;
}
</style>
